import clsx from 'clsx';

import { useIsElementShown } from '@/shared/hooks/use-is-element-shown';

interface HomePageCapabilitiesInfoProps {
  capabilityTitle?: string;
  description?: string;
}

export const HomePageCapabilitiesInfo = ({
  capabilityTitle,
  description
}: HomePageCapabilitiesInfoProps) => {
  const { isShown, ref } = useIsElementShown();

  return (
    <div
      className={clsx(
        'flex flex-col gap-4 sm:gap-5 will-change-transform',
        isShown
          ? 'translate-x-0 opacity-100 transition-all ease-in duration-700 delay-300'
          : 'translate-x-36 lg:translate-x-1/2 opacity-0'
      )}
      ref={ref}
    >
      {capabilityTitle && (
        <span
          key={`pill-${capabilityTitle}`}
          className="self-start px-4 py-1 border border-mantis rounded-full text-mantis text-xs sm:text-sm font-mono tracking-dense animate-fade-in"
        >
          {capabilityTitle}
        </span>
      )}

      {description && (
        <p
          key={`desc-${capabilityTitle}`}
          className="text-base sm:text-2xl text-left text-white leading-relaxed sm:leading-snug font-sans font-light tracking-normal animate-fade-in"
        >
          {description}
        </p>
      )}

      <p className="hidden lg:block text-xs text-mountain-mist font-mono font-normal tracking-dense mt-4">
        ↳ Click any orb on the sphere to explore.
      </p>
    </div>
  );
};
